var _style, _rect, _polygon, _polygon2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _rect16, _rect17, _rect18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8CBCFF;}\n\t.st1{opacity:0.21;fill:#FFFFFF;}\n\t.st2{opacity:0.13;fill:#FFFFFF;}\n\t.st3{fill:#939393;}\n\t.st4{fill:#3D3E3F;}\n\t.st5{fill:#818282;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 6,
    className: "st0",
    width: 28,
    height: 24
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.9,8 26.5,30 29.1,30 6.5,8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2.9,8 25.4,30 26,30 3.4,8 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    className: "st3",
    width: 32,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    className: "st4",
    width: 32,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    className: "st4",
    width: 22,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    className: "st4",
    width: 22,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    className: "st4",
    width: 30,
    height: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18,
    className: "st4",
    width: 30,
    height: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 23,
    className: "st4",
    width: 30,
    height: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 2,
    className: "st0",
    width: 4,
    height: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 1,
    className: "st5",
    width: 21,
    height: 5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 2,
    className: "st0",
    width: 3,
    height: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2,
    className: "st0",
    width: 3,
    height: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 2,
    className: "st0",
    width: 3,
    height: 3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 2,
    className: "st0",
    width: 3,
    height: 3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 2,
    className: "st0",
    width: 3,
    height: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.5,8v22h2.9v-5.5h3V30h7.1V8H9.5z M13.5,22.5h-3v-3h3V22.5z M13.5,17.5h-3v-3h3V17.5z M13.5,12h-3V9h3V12z  M17.5,22.5h-3v-3h3V22.5z M17.5,17.5h-3v-3h3V17.5z M17.5,12h-3V9h3V12z M21.5,22.5h-3v-3h3V22.5z M21.5,17.5h-3v-3h3V17.5z  M21.5,12h-3V9h3V12z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 22.4,
    className: "st4",
    width: 17,
    height: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4,
    y: 24.5,
    className: "st0",
    width: 5,
    height: 5.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 24.5,
    className: "st0",
    width: 5,
    height: 5.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.6a313a5fcc91f308490d544904011137.svg";
export { ForwardRef as ReactComponent };